import React from 'react';
import { UnpaidCustomers } from './UnpaidCustomers';

export function StripeSync() {
  return <UnpaidCustomers />;
}